import React from 'react';
import classNames from 'classnames';

import css from './IconShare.module.css';

const IconShare = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg className={classes} width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.79372 14.0769C6.49306 14.0769 7.87064 12.6994 7.87064 11C7.87064 9.30068 6.49306 7.9231 4.79372 7.9231C3.09438 7.9231 1.7168 9.30068 1.7168 11C1.7168 12.6994 3.09438 14.0769 4.79372 14.0769Z" stroke="#6E7191" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6394 7.15385C20.3388 7.15385 21.7163 5.77626 21.7163 4.07692C21.7163 2.37759 20.3388 1 18.6394 1C16.9401 1 15.5625 2.37759 15.5625 4.07692C15.5625 5.77626 16.9401 7.15385 18.6394 7.15385Z" stroke="#6E7191" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6394 21C20.3388 21 21.7163 19.6225 21.7163 17.9231C21.7163 16.2238 20.3388 14.8462 18.6394 14.8462C16.9401 14.8462 15.5625 16.2238 15.5625 17.9231C15.5625 19.6225 16.9401 21 18.6394 21Z" stroke="#6E7191" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.65625 8.55389L15.6563 4.81543" stroke="#6E7191" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.65625 13.446L15.6563 17.1845" stroke="#6E7191" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default IconShare;
